const styles = theme => ({
  paper: theme.mixins.gutters({
    paddingTop: 16,
    paddingBottom: 16,
    marginTop: 8,
    boxShadow: "none!important"
  }),
  table: {
    maxWidth: "100%"
  },
  heading: {
    fontWeight: "bold",
    color: "black !important",
    fontSize: "13pt",
    paddingTop: "30px",
    paddingBottom: "15px",
    zIndex: 2,
    textAlign: "left",
    width: "100%"
  },
  testText: {
    color: "black !important",
    fontSize: "12pt",
    textAlign: "center"
    // minWidth: "60px",
    // maxWidth: "60px"
  },
  mac_tableheader_first: {
    fontWeight: "bold",
    color: "black !important",
    fontSize: "12pt",
    textAlign: "right",
    width: "150px",
    paddingRight: "10px !important"
  },
  mac_tableheader: {
    fontWeight: "bold",
    color: "black !important",
    fontSize: "12pt",
    textAlign: "left",
    paddingLeft: "10px !important"
  },
  tableheader_first: {
    fontWeight: "bold",
    color: "black !important",
    fontSize: "12pt",
    textAlign: "left",
    width: "150px"
  },
  tableheader: {
    fontWeight: "bold",
    color: "black !important",
    fontSize: "12pt",
    textAlign: "center"
  },
  tableheaderlast: {
    fontWeight: "bold",
    color: "black !important",
    fontSize: "12pt",
    textAlign: "center"
  },
  tableheader_sub: {
    color: "black !important",
    fontSize: "12pt",
    //textAlign: "center",
    padding: "0px !important"
  },
  mac_tablecontent: {
    width: "320px",
    color: "black",
    fontSize: "12pt",
    textAlign: "right",
    paddingRight: "10px !important"
  },
  mac_tablecontent_right: {
    width: "320px",
    color: "black",
    fontSize: "12pt",
    textAlign: "left",
    paddingLeft: "10px !important"
  },
  copper_tablecontent_first: {
    width: "320px",
    color: "black",
    fontSize: "12pt",
    textAlign: "left",
    padding: "0 !important"
  },
  tablecontent: {
    color: "black",
    fontSize: "12pt",
    textAlign: "center"
  },
  tablecontent_first: {
    width: "320px",
    color: "black",
    fontSize: "12pt",
    textAlign: "left"
  },
  tablecontent_first_wide: {
    width: "530px",
    color: "black",
    fontSize: "12pt",
    textAlign: "left",
    padding: "0 !important"
  },
  error_tablecontent_first: {
    width: "320px",
    color: "red",
    fontSize: "12pt",
    textAlign: "left"
  },
  tablecontentlast: {
    //fontWeight: "bold",
    color: "black",
    fontSize: "12pt"
  },
  failState: {
    color: theme.palette.fail
  },
  passState: {
    color: theme.palette.success
  },
  div_table1: {
    paddingTop: 30
  },
  defaultText: {
    fontSize: "14px"
  },
  passedText: {
    color: "#4CAF50",
    fontSize: "14px"
  },
  failedText: {
    color: "#FF5252",
    fontSize: "14px"
  },
  totalGrid: {
    borderRight: "0.5px solid #D3D3D3",
    textAlign: "center"
  },
  totalGridLast: {
    textAlign: "center"
  },
  infoHead: {
    display: "flex",
    margin: "0 Auto",
    width: "80px"
  },
  pass: {
    margin: theme.spacing.unit,
    textAlign: "center"
  },
  table2: {
    overflow: "auto",
    height: 380
  },
  logo: {
    width: "auto",
    height: "50px",
    maxHeight: "50px",
    backgroundColor: "grey",
    border: "1px solid white",
    display: "inline-block",
    maxWidth: "300px"
  },
  polarity: {
    fontSize: "14px",
    paddingTop: "35px"
  },
  statusText: {
    paddingLeft: "10px"
  },
  infoText: {
    paddingTop: "2px"
  },
  tab: {
    width: "240px !important"
  },
  tabHeader: {
    paddingTop: "25px"
  },
  gridHeader: {
    paddingTop: "10px"
  },
  disclaimer: {
    paddingTop: "10px"
  },
  disclaimerGrid: {
    borderBottom: "0.5px solid #D3D3D3"
  },
  vtabHeaderFirst: {
    background: "#f2f2f2",
    padding: "15px 35px 15px 15px",
    border: "1px solid #ddd",
    textAlign: "left",
    width: "90px",
    fontWeight: "bold",
    color: "black !important",
    fontSize: "12pt"
  },
  vtabHeader: {
    background: "#f2f2f2",
    padding: "15px 35px 15px 35px",
    border: "1px solid #ddd",
    width: "75px",
    //textAlign: "center"
    fontWeight: "bold",
    color: "black !important",
    fontSize: "12pt"
  },
  vtabDataFirst: {
    border: "1px solid #ddd",
    padding: "15px 35px 15px 15px",
    textAlign: "left",
    fontSize: "12pt"
  },
  vtabData: {
    border: "1px solid #ddd",
    textAlign: "center",
    fontSize: "12pt"
  },
  vSetupTitle: {
    fontSize: "11pt",
    padding: "10px 0px 15px 0px"
  },
  vSetupText: {
    fontSize: "11pt",
    padding: "10px 0px 15px 60px"
  },
  vSetupDiv: {
    display: "flex"
  },
  VLeftGrid: {
    borderTop: "0.5px solid #D3D3D3"
  },
  radioGroup: {
    display: "block !important"
  },
  voltageGrid: {
    borderLeft: "0.5px solid #D3D3D3",
    borderColor: "black"
  },
  itabVoltageHeader: {
    //background: "#f2f2f2",
    padding: "15px 35px 15px 35px",
    border: "1px solid #ddd",
    width: "70px",
    textAlign: "center",
    fontWeight: "bold",
    color: "black !important",
    fontSize: "12pt"
  },
  itabVoltageData: {
    //background: "#f2f2f2",
    padding: "15px 35px 15px 35px",
    border: "1px solid #ddd",
    width: "70px",
    textAlign: "center",
    fontWeight: "normal !important",
    color: "black !important",
    fontSize: "12pt"
  },
  itabPairHeader: {
    //background: "#f2f2f2",
    padding: "15px 15px 15px 15px",
    border: "1px solid #ddd",
    width: "39.5px",
    textAlign: "center",
    fontWeight: "bold",
    color: "black !important",
    fontSize: "12pt"
  },
  itabPairData: {
    //background: "#f2f2f2",
    padding: "15px 15px 15px 15px",
    border: "1px solid #ddd",
    width: "39.5px",
    textAlign: "center",
    fontWeight: "normal !important",
    color: "black !important",
    fontSize: "12pt"
  },
  // Every nested heading/value table in the copper interface view uses itabTable,
  // so all of them have the same width and start at the same position.
  // Columns are then split evenly with itabCols2/3/4, which makes the dividers
  // symmetric: 2 columns split at the middle, 4 columns split into quarters,
  // 3 columns into thirds (the middle column is centred under the 2-column divider).
  itabTable: {
    tableLayout: "fixed", // use the widths below, don't size columns to content
    width: "360px",
    borderCollapse: "collapse",
    "& th": {
      boxSizing: "border-box",
      overflowWrap: "break-word"
    }
  },
  itabCols2: {
    "& th": { width: "50%" } // Pair 12-36 / Pair 45-78
  },
  itabCols3: {
    "& th": { width: "33.333%" } // Requested / Allocated / Measured
  },
  itabCols4: {
    "& th": { width: "25%" } // Pair 1-2 / 3-6 / 4-5 / 7-8
  },
  itabLldpPoeHeader: {
    padding: "15px 10px",
    textAlign: "center",
    fontWeight: "bold",
    color: "black !important",
    fontSize: "12pt",
    overflowWrap: "break-word" // long translated headings wrap instead of widening the column
  },
  itabLldpPoeData: {
    padding: "15px 10px",
    textAlign: "center",
    fontWeight: "normal !important",
    color: "black !important",
    fontSize: "12pt",
    whiteSpace: "nowrap"
  },
  skew_row: {
    background: "#ddd"
  },
  discovery_col: {
    maxWidth: "30px",
    minWidth: "30px",
    textAlign: "center",
    padding: "0px !important"
  },
  discovery_col_header: {
    maxWidth: "30px",
    minWidth: "30px",
    textAlign: "center",
    padding: "0px !important",
    color: "black !important",
    fontWeight: "bold"
  },
  div_table2: {
    height: 300,
    overflow: "auto"
  },
  mac_heading: {
    maxHeight: "50px"
    //textAlign:'center'
  },
  tableheader_sub_vlan: {
    color: "black !important",
    fontSize: "12pt",
    textAlign: "center",
    whiteSpace: "nowrap"
  },
  div_image: {
    paddingTop: 50,
    transition: "transform 0.001s ease",
    display: "block"
  },
  div_image_zoomed: {
    marginTop: 40,
    transform: "scale(2)",
    transition: "transform 0.001s ease; translate(-50%, -50%)",
    display: "flex",
    zIndex: 1,
    alignItems: "center",
    marginBottom: 80,
    display: "block",
    transformOrigin: "top left"
  },
  hidden_div: {
    display: "none"
  },
  image_container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    marginBottom: 80
  },
  zoom_button: {
    marginTop: 40,
    backgroundColor: "#1976d2",
    color: "white",
    width: 40,
    height: 40,
    borderRadius: 20,
    fontSize: 24,
    fontWeight: "bold",
    boxShadow: "0px 2px 5px rgba(0,0,0,0.3)",
    "&:hover": {
      backgroundColor: "#1565c0"
    },
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: 0
  }
});

export default styles;
